"use client";

import { reportWebVitalMetric } from "@website/widget/scripts/web-vitals/reporter";
import { useReportWebVitals } from "next/web-vitals";
export function WebVitals() {
  useReportWebVitals(reportWebVitalMetric);
  return null;
}